export const newsList = [
  {
    id: "gp9001",
    title: "2026春节档影片总票房突破80亿，多部国产大片刷新纪录",
    date: "2026-02-18",
    category: "新闻",
    author: "本站编辑部",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20cinema%20hall%20entrance%20at%20night%20with%20glowing%20poster%20boards%20and%20crowds%20of%20movie%20goers%2C%20warm%20red%20and%20gold%20lighting%2C%20festive%20atmosphere%2C%20cinematic%20street%20scene%2C%20wide%20composition&width=800&height=500&seq=gp-news-01&orientation=landscape",
    summary: "为期七天的春节档圆满收官，多部国产影片口碑与票房双丰收，刷新多项影史纪录。",
    content: [
      "为期七天的春节档正式收官。据初步统计，今年春节档总票房成功突破80亿元，观影人次创下历史新高，多部国产影片凭借扎实的品质与良好的口碑实现票房逆袭。",
      "其中，科幻题材与现实主义题材表现尤为亮眼，既有恢弘的视觉奇观，也不乏贴近生活的细腻表达，满足了不同观众群体的观影需求。多部影片在假期后半程依靠口碑持续发力，走出漂亮的票房曲线。",
      "业内人士表示，观众对内容品质的要求越来越高，单纯依靠流量与话题已难以长期吸引观众。扎实的剧本、真诚的表达与精良的制作，正在成为国产电影赢得市场的关键。",
      "随着档期结束，多部影片宣布延长放映周期，进一步释放市场潜力。接下来还将有一批备受期待的作品陆续定档，全年电影市场值得期待。"
    ]
  },
  {
    id: "gp9002",
    title: "《长夜将明》主创专访：用真实质感讲述小人物的坚守",
    date: "2026-01-22",
    category: "报道",
    author: "林晓",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Warm%20interview%20studio%20with%20a%20director%20and%20actors%20seated%20in%20soft%20spotlight%2C%20minimal%20set%20with%20vertical%20light%20panels%2C%20muted%20red%20and%20cream%20tones%2C%20professional%20editorial%20photography%2C%20wide%20composition&width=800&height=500&seq=gp-news-02&orientation=landscape",
    summary: "从剧本打磨到实地取景，主创团队分享了这部现实主义犯罪片背后的创作故事。",
    content: [
      "现实主义犯罪片《长夜将明》上映以来，凭借扎实的叙事与出色的表演收获了观众的广泛好评。近日，影片导演与主演接受了本站专访，分享了创作背后的点滴。",
      "导演表示，影片最初的灵感来源于一则关于陈年旧案的报道。“我们想讲的不是案件本身，而是那些在漫长等待中依然选择坚守的普通人。”为了还原真实的质感，团队在城中村与老工业区实地取景长达数月。",
      "谈及角色塑造，主演坦言为了贴近人物状态，提前体验了基层民警的日常工作。“当你真正走近他们，才会明白那份沉默背后有多重的分量。”",
      "主创团队希望，观众在走出影院之后，能够记住的不只是真相揭晓的那一刻，更是那些平凡人身上不曾熄灭的光。"
    ]
  },
  {
    id: "gp9003",
    title: "科幻巨制《山海归途》发布首支预告，视觉奇观引爆期待",
    date: "2026-02-05",
    category: "预告",
    author: "本站编辑部",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20space%20scene%20with%20a%20lone%20spacecraft%20passing%20a%20giant%20glowing%20planet%2C%20cosmic%20dust%20and%20light%20trails%2C%20deep%20red%20and%20golden%20nebula%20tones%2C%20epic%20science%20fiction%20film%20still%2C%20wide%20composition&width=800&height=500&seq=gp-news-03&orientation=landscape",
    summary: "预告片中恢弘的宇宙场景与细腻的人物情感交织，让观众对这部年度科幻大片充满期待。",
    content: [
      "备受期待的国产科幻电影《山海归途》今日发布首支官方预告，两分半钟的画面中，恢弘的宇宙奇观与细腻的人物情感交织呈现，迅速引发网友热议。",
      "预告片以“回家”为线索，展现了飞船在深空中遭遇危机、船员们彼此扶持的片段。震撼的视听效果与克制的情绪表达形成强烈张力，不少观众表示“光看预告就已经起鸡皮疙瘩”。",
      "据制片方介绍，影片在视效制作上投入了大量心血，力求让每一个镜头都经得起大银幕的考验。同时，团队也希望在硬核科幻的外壳之下，传递关于勇气与归途的温暖内核。",
      "影片将于年内与观众见面，更多幕后花絮与制作特辑也将陆续公开。"
    ]
  },
  {
    id: "gp9004",
    title: "广电总局发布新一批精品剧集扶持名单，现实题材占比提升",
    date: "2025-12-30",
    category: "新闻",
    author: "本站编辑部",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Modern%20conference%20hall%20with%20rows%20of%20empty%20seats%20and%20a%20large%20screen%2C%20warm%20cream%20and%20red%20decor%2C%20clean%20minimal%20editorial%20lighting%2C%20wide%20composition&width=800&height=500&seq=gp-news-04&orientation=landscape",
    summary: "新一批扶持名单公布，现实题材与主旋律作品的比重进一步提升，鼓励优质原创内容。",
    content: [
      "有关部门近日公布了新一批精品剧集扶持名单，共有多部作品入选，涵盖现实题材、历史正剧与科幻等多个方向。",
      "从名单来看，现实题材作品的占比继续提升，聚焦基层生活、时代变迁与普通人奋斗故事的作品受到更多关注。同时，鼓励创新表达与类型融合也成为本次名单的一大特点。",
      "业内认为，扶持政策将引导更多创作者把重心放回内容本身，推动国产剧集整体品质稳步提升，为观众带来更多有温度、有深度的作品。"
    ]
  },
  {
    id: "gp9005",
    title: "国剧出海：越来越多国产剧集登陆海外主流平台",
    date: "2026-01-10",
    category: "报道",
    author: "陈默",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Modern%20world%20map%20wall%20with%20glowing%20connection%20lines%20and%20small%20screens%20showing%20asian%20dramas%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20clean%20studio%20editorial%20photography%2C%20wide%20composition&width=800&height=500&seq=gp-news-05&orientation=landscape",
    summary: "从古装到都市，从悬疑到家庭，国产剧集正以更丰富的面貌走向海外观众的视野。",
    content: [
      "近年来，国产剧集出海的步伐明显加快。越来越多的作品被海外流媒体平台引进，以多语言字幕和配音的形式与全球观众见面，题材也从单一的古装扩展到都市、悬疑、家庭等多个类型。",
      "有分析指出，扎实的叙事与真挚的情感是国产剧集打动海外观众的关键。相比刻意迎合，那些根植于本土生活、讲述共通情感的作品，往往更容易引发共鸣。",
      "与此同时，制作水准的提升也让国产剧集在国际市场竞争中更具底气。未来，随着合作渠道的进一步拓宽，国产内容的海外影响力有望持续扩大。"
    ]
  },
  {
    id: "gp9006",
    title: "《雾隐迷城》定档3月，悬疑剧再掀追剧热潮",
    date: "2026-02-20",
    category: "预告",
    author: "本站编辑部",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Foggy%20mysterious%20old%20chinese%20town%20street%20at%20dusk%20with%20dim%20lamps%20and%20silhouettes%2C%20dense%20mist%2C%20cold%20gray%20with%20faint%20red%20glow%2C%20cinematic%20thriller%20still%2C%20wide%20composition&width=800&height=500&seq=gp-news-06&orientation=landscape",
    summary: "这部备受关注的悬疑剧正式定档，精良的制作与烧脑的剧情让观众期待值拉满。",
    content: [
      "悬疑剧《雾隐迷城》近日正式宣布定档，将于3月登陆荧屏。该剧自开拍以来便备受关注，此前发布的物料以浓郁的悬疑氛围吊足了观众胃口。",
      "据悉，剧集围绕一座被浓雾笼罩的小镇展开，通过多起看似独立的案件层层递进，最终拼凑出一个完整的真相。编剧团队在打磨剧本时数易其稿，力求逻辑严密、反转合理。",
      "随着定档消息公布，相关话题迅速登上热搜，不少悬疑剧爱好者表示“终于等到”。剧集能否延续近年来国产悬疑剧的良好口碑，值得期待。"
    ]
  },
  {
    id: "gp9007",
    title: "影视行业年度盘点：现实题材成国产剧创作主流",
    date: "2025-12-15",
    category: "新闻",
    author: "本站编辑部",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Modern%20editorial%20desk%20with%20film%20reels%2C%20scripts%20and%20a%20laptop%20showing%20charts%2C%20warm%20amber%20lighting%2C%20clean%20minimal%20workspace%2C%20wide%20composition&width=800&height=500&seq=gp-news-07&orientation=landscape",
    summary: "年度回顾显示，贴近生活、关注时代的现实题材作品成为国产剧集中最受瞩目的一类。",
    content: [
      "过去一年，国产剧集市场持续回暖，涌现出一批口碑与热度兼具的作品。从题材分布来看，现实题材成为当之无愧的主流，聚焦家庭、职场、都市与时代变迁的故事层出不穷。",
      "观众审美的成熟推动创作风向的变化。相比纯粹的爽感与话题，人们越来越看重作品能否带来真实的情感触动与思考空间。",
      "与此同同时，类型融合成为新的趋势，悬疑、科幻等元素与现实题材结合，为国产剧集带来了更丰富的表达可能。展望新的一年，行业对高质量原创内容的投入力度还将继续加大。"
    ]
  },
  {
    id: "gp9008",
    title: "青年导演崛起：新生代创作者带来哪些新表达",
    date: "2026-01-28",
    category: "报道",
    author: "苏晚",
    source: "国产精品久久影视观察",
    cover: "https://readdy.ai/api/search-image?query=Young%20asian%20film%20director%20with%20camera%20on%20a%20set%20with%20warm%20studio%20lighting%2C%20crew%20in%20soft%20focus%20background%2C%20amber%20and%20cream%20tones%2C%20editorial%20documentary%20style%2C%20wide%20composition&width=800&height=500&seq=gp-news-08&orientation=landscape",
    summary: "一批青年创作者正以独特的视角与大胆的尝试，为国产影视注入新鲜血液。",
    content: [
      "在今年的多部热门作品中，青年导演的身影格外活跃。他们带着对生活的独特观察与不拘一格的表达方式，为国产影视带来了令人耳目一新的气象。",
      "与前辈相比，这一代创作者成长于互联网时代，对观众的审美与情绪有着更敏锐的感知。他们的作品往往节奏明快、情感直接，同时也不乏对现实议题的关注。",
      "当然，成长的道路上仍有挑战。如何在个人表达与大众接受之间找到平衡，如何驾驭更复杂的题材与更大的制作规模，都是他们需要持续面对的课题。",
      "可以预见，随着这批新生力量的不断成熟，国产影视的创作生态将更加多元与充满活力。"
    ]
  }
];

export const newsCategories = ["新闻", "报道", "预告", "全部"];